import {AfterViewInit, Component, OnDestroy, ViewChild , OnInit } from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Partner} from '../../../shared/interface/partner';
import {PartnerService} from '../../../shared/services/partner.service';
import {ReplaySubject} from 'rxjs';
import {CountedAndPaginated} from '../../../shared/interface/response/counted-and-paginated';
import {NgForm} from '@angular/forms';
import {delay, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {Uuid} from '../../../shared/interface/response/uuid';
import {JobResultDialogComponent} from '../../../shared/components/job-result-dialog/job-result-dialog.component';
import {HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {FilterService} from '../../../shared/services/filter.service';
import {select, Store} from '@ngrx/store';
import {StoreRootState} from '../../../shared/ngrx/reducers';
import {getCurrentRouteState} from '../../../shared/ngrx/selector';
import {RouterStateUrl} from '../../../shared/ngrx/route-serializer';

@Component({
  selector: 'app-search-engine',
  templateUrl: './search-engine.component.html',
  styleUrls: ['./search-engine.component.scss']
})
export class SearchEngineComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  initialFilters: any;
  displayedColumns: string[] = ['fullname', 'name', 'status', 'nip', 'headquartersAddress', 'assetsRegional'];
  dataSource: Partner[] = [];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  active = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);


  constructor(
    private partnerService: PartnerService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.partnerService.getPartnerSearchEngineListSubject()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((result: CountedAndPaginated<Partner>) => {
        this.dataSource = result.items;
        this.totalData = result.pagination.total;
      });
    this.parseFilters();
  }

  ngOnInit(): void {
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      nipFull: 'string',
      zipCode: 'string',
    }, filters);
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate(['partnerzy/wyszukiwarka', this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  filter(): void {
    this.router.navigate(['partnerzy/wyszukiwarka', this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadListData(): void {
    this.partnerService.searchEngine(this.paginator.pageIndex, this.paginator.pageSize, this.initialFilters);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate(['partnerzy/wyszukiwarka', {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }
}


